function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "OrderDraw",
  transform: "translate(-43.576 2.308)"
}, /*#__PURE__*/React.createElement("g", {
  id: "MaoFundo"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_148",
  "data-name": "Caminho 148",
  d: "M551.918,398.458s-70.611,2.278-82.315-23.884,10.327-90.88,10.327-90.88l48.882,26.851Z",
  transform: "translate(-369.779 -227.292)",
  fill: "#9f616a"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_149",
  "data-name": "Caminho 149",
  d: "M362.894,243.4l-14.458,1.377s-7.573,16.524,15.835,17.9Z",
  transform: "translate(-303.69 -204.895)",
  fill: "#9f616a"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_150",
  "data-name": "Caminho 150",
  d: "M362.894,300.743l-14.458,1.377s-7.573,16.524,15.835,17.9Z",
  transform: "translate(-303.69 -236.768)",
  fill: "#9f616a"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_151",
  "data-name": "Caminho 151",
  d: "M362.894,362.739l-14.458,1.377s-7.573,16.524,15.835,17.9Z",
  transform: "translate(-303.69 -271.224)",
  fill: "#9f616a"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_152",
  "data-name": "Caminho 152",
  d: "M372.194,424.735l-14.458,1.377s-7.573,16.524,15.835,17.9Z",
  transform: "translate(-308.859 -305.681)",
  fill: "#9f616a"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_83",
  "data-name": "Ret\\xE2ngulo 83",
  width: 0.444,
  height: 9.075,
  transform: "translate(44.669 40.086) rotate(-69.778)",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_84",
  "data-name": "Ret\\xE2ngulo 84",
  width: 0.444,
  height: 9.075,
  transform: "translate(44.669 65.85) rotate(-69.778)",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_85",
  "data-name": "Ret\\xE2ngulo 85",
  width: 0.444,
  height: 9.075,
  transform: "translate(44.669 93.392) rotate(-69.778)",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_86",
  "data-name": "Ret\\xE2ngulo 86",
  width: 0.444,
  height: 4.599,
  transform: "translate(49.092 120.924) rotate(-64.361)",
  opacity: 0.2
})), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_76",
  "data-name": "Caminho 76",
  d: "M366.6,197.687h1.01V163.159c.075-7.712,4.584-11.306,10-11.53l71.807-.112c4.284.225,8.868,3.519,8.868,11.381l-.119,174.175c-.126,2.531-2.526,8.731-8.966,8.7H377.847c-6.061-.1-10.481-4.272-10.481-11.1L367.61,218.5H366.6Z",
  transform: "translate(-309.021 -153.824)",
  fill: "#222d3c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_100",
  "data-name": "Caminho 100",
  d: "M396.91,94.174V268.095a7.818,7.818,0,0,1-7.816,7.811H318.487a7.8,7.8,0,0,1-7.816-7.811V94.174a7.815,7.815,0,0,1,7.817-7.816h10.565v1.355a6.436,6.436,0,0,0,6.435,6.437H371.4a6.383,6.383,0,0,0,3.815-1.256,5.983,5.983,0,0,0,.633-.531,6.417,6.417,0,0,0,1.986-4.65V86.358h11.261A7.814,7.814,0,0,1,396.91,94.174Z",
  transform: "translate(-249.924 -86.469)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_9",
  "data-name": "Elipse 9",
  cx: 1.878,
  cy: 1.878,
  r: 1.878,
  transform: "translate(78.539 26.989)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_101",
  "data-name": "Caminho 101",
  d: "M551.854,108.738a5.982,5.982,0,0,1-.633.531,33.606,33.606,0,0,0,21.7,16.15v-.837A32.815,32.815,0,0,1,551.854,108.738Z",
  transform: "translate(-425.931 -102.844)",
  fill: "#6c63ff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_102",
  "data-name": "Caminho 102",
  d: "M491.371,115.4h-.88a48.744,48.744,0,0,0,37.99,30.333V144.9A47.907,47.907,0,0,1,491.371,115.4Z",
  transform: "translate(-381.495 -107.717)",
  fill: "#6c63ff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_103",
  "data-name": "Caminho 103",
  d: "M431.039,115.4h-.848a64.269,64.269,0,0,0,54.17,45.914v-.818A63.452,63.452,0,0,1,431.039,115.4Z",
  transform: "translate(-337.375 -107.717)",
  fill: "#6c63ff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_104",
  "data-name": "Caminho 104",
  d: "M263.5,158.489h-.489V158h-.1v.489h-.489v.1h.489v.489h.1v-.489h.489Z",
  transform: "translate(-189.253 -115.717)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_105",
  "data-name": "Caminho 105",
  d: "M386.5,67.489h-.489V67h-.1v.489h-.489v.1h.489v.489h.1v-.489h.489Z",
  transform: "translate(-279.251 -49.134)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_106",
  "data-name": "Caminho 106",
  d: "M281.5,230.489h-.489V230h-.1v.489h-.489v.1h.489v.489h.1v-.489h.489Z",
  transform: "translate(-202.423 -168.399)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_107",
  "data-name": "Caminho 107",
  d: "M365.5,177.489h-.489V177h-.1v.489h-.489v.1h.489v.489h.1v-.489h.489Z",
  transform: "translate(-263.885 -129.619)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_108",
  "data-name": "Caminho 108",
  d: "M485.5,210.489h-.489V210h-.1v.489h-.489v.1h.489v.489h.1v-.489h.489Z",
  transform: "translate(-351.688 -153.765)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_10",
  "data-name": "Elipse 10",
  cx: 1.073,
  cy: 1.073,
  r: 1.073,
  transform: "translate(127.104 32.355)",
  fill: "#ff6584"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_109",
  "data-name": "Caminho 109",
  d: "M417.02,305.158l-.609.094c.19,1.218.341,2.463.451,3.695l.614-.054C417.366,307.645,417.213,306.39,417.02,305.158Z",
  transform: "translate(-327.292 -246.562)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_110",
  "data-name": "Caminho 110",
  d: "M410.861,277.818l-.59.18c.357,1.181.676,2.391.947,3.6l.6-.137C411.546,280.238,411.221,279.015,410.861,277.818Z",
  transform: "translate(-322.799 -226.557)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_111",
  "data-name": "Caminho 111",
  d: "M401.032,251.6l-.561.258c.515,1.124,1,2.278,1.435,3.432l.577-.217C402.041,253.9,401.555,252.733,401.032,251.6Z",
  transform: "translate(-315.629 -207.372)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_112",
  "data-name": "Caminho 112",
  d: "M387.742,227.018l-.521.33c.663,1.041,1.3,2.12,1.889,3.2l.542-.3C389.056,229.159,388.412,228.07,387.742,227.018Z",
  transform: "translate(-305.934 -189.388)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_113",
  "data-name": "Caminho 113",
  d: "M371.221,204.488l-.47.4c.8.939,1.578,1.921,2.313,2.914l.494-.368C372.817,206.431,372.031,205.438,371.221,204.488Z",
  transform: "translate(-293.883 -172.903)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_114",
  "data-name": "Caminho 114",
  d: "M351.8,184.428l-.411.459c.923.824,1.827,1.69,2.688,2.573l.443-.432C353.65,186.134,352.735,185.26,351.8,184.428Z",
  transform: "translate(-279.718 -158.225)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_115",
  "data-name": "Caminho 115",
  d: "M329.857,167.208l-.346.51c1.025.69,2.039,1.425,3.013,2.184l.381-.486C331.918,168.649,330.893,167.906,329.857,167.208Z",
  transform: "translate(-263.708 -145.625)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_116",
  "data-name": "Caminho 116",
  d: "M310.671,155.248v.7c.641.335,1.277.687,1.9,1.046l.309-.534Q311.793,155.83,310.671,155.248Z",
  transform: "translate(-249.924 -136.874)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_117",
  "data-name": "Caminho 117",
  d: "M418.161,516.2c.1-.6.192-1.213.272-1.821l.612.081c-.082.615-.174,1.234-.275,1.841Z",
  transform: "translate(-328.572 -399.644)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_118",
  "data-name": "Caminho 118",
  d: "M411.752,538.352l.59.184c.37-1.192.7-2.414.995-3.631l-.6-.142C412.448,535.967,412.119,537.173,411.752,538.352Z",
  transform: "translate(-323.883 -414.561)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_119",
  "data-name": "Caminho 119",
  d: "M401.71,564.648l.56.262c.532-1.129,1.03-2.292,1.482-3.457l-.576-.225C402.73,562.381,402.237,563.532,401.71,564.648Z",
  transform: "translate(-316.536 -433.925)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_120",
  "data-name": "Caminho 120",
  d: "M388.2,589.511l.517.336c.682-1.046,1.337-2.131,1.946-3.222l-.538-.3C389.523,587.4,388.874,588.474,388.2,589.511Z",
  transform: "translate(-306.65 -452.286)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_121",
  "data-name": "Caminho 121",
  d: "M371.482,612.458l.468.405c.821-.947,1.617-1.931,2.371-2.927l-.494-.369C373.083,610.551,372.3,611.524,371.482,612.458Z",
  transform: "translate(-294.418 -469.293)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_122",
  "data-name": "Caminho 122",
  d: "M351.907,633.044l.406.464c.943-.823,1.866-1.691,2.748-2.574l-.436-.437C353.753,631.37,352.838,632.226,351.907,633.044Z",
  transform: "translate(-280.095 -484.608)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_123",
  "data-name": "Caminho 123",
  d: "M329.855,650.909l.341.516c1.042-.688,2.076-1.421,3.069-2.177l-.373-.493C331.909,649.505,330.887,650.23,329.855,650.909Z",
  transform: "translate(-263.96 -497.968)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_124",
  "data-name": "Caminho 124",
  d: "M312.949,664.552c-.746.421-1.508.829-2.278,1.216v-.692c.665-.338,1.325-.7,1.972-1.057Z",
  transform: "translate(-249.924 -509.135)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_125",
  "data-name": "Caminho 125",
  d: "M418.836,333.433l.617-.011c.011.623.012,1.249,0,1.861l-.617-.01C418.848,334.668,418.847,334.049,418.836,333.433Z",
  transform: "translate(-329.066 -267.242)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_16",
  "data-name": "Elipse 16",
  cx: 33.51,
  cy: 33.51,
  r: 33.51,
  transform: "translate(70.933 81.223)",
  fill: "#6c63ff",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_17",
  "data-name": "Elipse 17",
  cx: 23.598,
  cy: 23.598,
  r: 23.598,
  transform: "translate(80.844 91.134)",
  fill: "#6c63ff",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_18",
  "data-name": "Elipse 18",
  cx: 15.575,
  cy: 15.575,
  r: 15.575,
  transform: "translate(88.868 99.157)",
  fill: "#6c63ff"
}), /*#__PURE__*/React.createElement("g", {
  id: "order-draw",
  transform: "translate(38.58 -2.308)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_78",
  "data-name": "Caminho 78",
  d: "M641.188,386.241l-24.017-38.463-2.754-56.456L585.5,243.128l-8.262-20.655s-19.278,2.065-3.442,41.309l6.541,21h0a96.249,96.249,0,0,0-8.95,40.532v48.119C581.274,401.684,597.7,411.878,641.188,386.241Z",
  transform: "translate(-469.699 -190.958)",
  fill: "#9f616a"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_79",
  "data-name": "Caminho 79",
  d: "M236.946,99.567l5.749-2.825-.2-.4-5.311,2.611-8.018-21.021-.415.159Z",
  transform: "translate(-127.139 -43.313)",
  opacity: 0.2
})), /*#__PURE__*/React.createElement("g", {
  id: "Order",
  transform: "translate(92.439 103.359)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_36",
  "data-name": "Caminho 36",
  d: "M19.508,14.674V8a1.668,1.668,0,0,0-.834-1.442L12.838,3.226a1.668,1.668,0,0,0-1.668,0L5.334,6.561A1.668,1.668,0,0,0,4.5,8v6.67a1.668,1.668,0,0,0,.834,1.442l5.836,3.335a1.668,1.668,0,0,0,1.668,0l5.836-3.335A1.667,1.667,0,0,0,19.508,14.674Z",
  transform: "translate(0 0)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_37",
  "data-name": "Caminho 37",
  d: "M4.905,10.44l7.279,4.21,7.279-4.21",
  transform: "translate(-0.18 -3.303)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_38",
  "data-name": "Caminho 38",
  d: "M18,26.4V18",
  transform: "translate(-5.996 -6.661)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_43",
  "data-name": "Caminho 43",
  d: "M155.293,1678.185l7.434,4.2",
  transform: "translate(-146.897 -1673.354)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 1.5
})), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_87",
  "data-name": "Ret\\xE2ngulo 87",
  width: 55,
  height: 7,
  rx: 2,
  transform: "translate(76.576 56.362)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_90",
  "data-name": "Ret\\xE2ngulo 90",
  width: 41,
  height: 7,
  rx: 2,
  transform: "translate(83.576 44.362)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_89",
  "data-name": "Ret\\xE2ngulo 89",
  width: 63,
  height: 7,
  rx: 2,
  transform: "translate(72.576 68.362)",
  fill: "#6c63ff"
}));

var SvgOrderDraw = function SvgOrderDraw(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166.493,
    height: 209.986,
    viewBox: "0 0 166.493 209.986",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOrderDraw, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Order-draw.3fdca0ed.svg";
export { ForwardRef as ReactComponent };